// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – archívum böngésző.
 *
 * A `window.TUDASFM_ARCHIVE` (lásd data/archive.js) tömbből kártyákat renderel,
 * kategória-chipeket épít, és kereső + kategória szűrést biztosít deklaratív
 * tömbműveletekkel. Nincs build, nincs framework; klasszikus <script>-ként fut.
 *
 * A média-forrás még nem dőlt el, ezért ahol nincs `mediaUrl`, a kártya
 * „Meghallgatás – hamarosan” állapotot mutat (letiltott gomb).
 */
function initArchive() {
  const data = window.TUDASFM_ARCHIVE || [];
  const grid = document.getElementById('archive-grid');
  const chipsBox = document.getElementById('archive-chips');
  const searchInput = document.getElementById('archive-search');
  const emptyState = document.getElementById('archive-empty');

  if (grid === null || chipsBox === null || searchInput === null || emptyState === null) {
    return;
  }

  const ALL = 'all';
  let activeCategory = ALL;
  let searchTerm = '';

  // Egyedi kategóriák az „Összes” chippel az élen.
  const categories = [ALL, ...new Set(data.map((item) => item.category))];

  const matches = (item) => {
    const inCategory = activeCategory === ALL || item.category === activeCategory;
    const haystack = `${item.title} ${item.description}`.toLowerCase();
    const inSearch = searchTerm === '' || haystack.includes(searchTerm);
    return inCategory && inSearch;
  };

  const buildCard = (item) => {
    const card = document.createElement('article');
    card.className = 'card';

    const meta = document.createElement('div');
    meta.className = 'card__meta';

    const category = document.createElement('span');
    category.className = 'card__category';
    category.textContent = item.category;

    const date = document.createElement('span');
    date.className = 'card__date';
    date.textContent = item.date;

    meta.append(category, date);

    const title = document.createElement('h3');
    title.className = 'card__title';
    title.textContent = item.title;

    const desc = document.createElement('p');
    desc.className = 'card__desc';
    desc.textContent = item.description;

    // A média-forrás bekötéséig letiltott „hamarosan” gomb; ha van mediaUrl,
    // aktív linkként viselkedik.
    const hasMedia = item.mediaUrl !== '' && item.mediaUrl !== undefined;
    const action = document.createElement(hasMedia ? 'a' : 'button');
    action.className = hasMedia ? 'card__action card__action--ready' : 'card__action';

    if (hasMedia) {
      action.textContent = 'Meghallgatás';
      action.href = item.mediaUrl;
      action.rel = 'noopener';
      action.target = '_blank';
    } else {
      action.type = 'button';
      action.textContent = 'Meghallgatás – hamarosan';
      action.disabled = true;
    }

    card.append(meta, title, desc, action);
    return card;
  };

  const renderGrid = () => {
    const visible = data.filter(matches);
    grid.replaceChildren(...visible.map(buildCard));
    emptyState.hidden = visible.length > 0;
  };

  const buildChips = () => {
    const chips = categories.map((category) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'chip';
      chip.textContent = category === ALL ? 'Összes' : category;
      chip.setAttribute('aria-pressed', `${category === activeCategory}`);

      chip.addEventListener('click', () => {
        activeCategory = category;
        chipsBox.querySelectorAll('.chip').forEach((element, index) => {
          element.setAttribute('aria-pressed', `${categories[index] === activeCategory}`);
        });
        renderGrid();
      });

      return chip;
    });

    chipsBox.replaceChildren(...chips);
  };

  searchInput.addEventListener('input', (event) => {
    searchTerm = event.target.value.trim().toLowerCase();
    renderGrid();
  });

  buildChips();
  renderGrid();
}

initArchive();
